import React from 'react'
import { cartMobx, discountMobx } from 'mobx/mall'
import { orderMobx } from 'restaurant'
import { modalLayer } from '@utils'
import { observer } from 'mobx-react'
import { memberMobx } from 'mobx/mkt'
import { format, toPrice } from '@dt/fe-utils'
import { ConfirmModal } from '@cps'
import { CouponModal } from '@pages/checkout/modal'
import { PromoCodeModal } from '../'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import SwitchCardModal from 'components/mkt/SwitchCardModal'
import { ActivityModal } from '../../modal'
import './index.scss'

const CheckoutDiscount = () => {
  const viewOrder = orderMobx.viewOrder
  const cartResult = cartMobx.cartResult
  const showCoupon = () => {
    const selectCouponIds = cloneDeep(discountMobx.discountAction.selectCouponIds)
    const selectItemCouponIds = cloneDeep(discountMobx.discountAction.selectItemCouponIds)
    // const selectPromoCodes = cloneDeep(discountMobx.discountAction.promoCodes)
    modalLayer(CouponModal, { tabsType: 'noPromoCode', type: 'mall' }, 'couponModal').then((res: any) => {
      // discountMobx.setPromoCode(res || '')
    }).catch(() => {
      discountMobx.setSelectCoupon(selectCouponIds, selectItemCouponIds)
    })
  }

  const showPromoCode = () => {
    const selectCouponIds = cloneDeep(discountMobx.discountAction.selectCouponIds)
    const selectItemCouponIds = cloneDeep(discountMobx.discountAction.selectItemCouponIds)
    // const selectPromoCodes = cloneDeep(discountMobx.discountAction.promoCodes)
    modalLayer(PromoCodeModal, null, 'PromoCodeModal').then((res: any) => {
      // discountMobx.setPromoCode(res || '')
    }).catch(() => {
      discountMobx.setSelectCoupon(selectCouponIds, selectItemCouponIds)
    })
  }
  // 关于提示语的百分比和具体数字
  const showIntegralRule = () => {
    const { card } = memberMobx.mallCardInfo
    modalLayer(ConfirmModal, {
      title: i18n.t('cart.integralRule'),
      confirmText: i18n.t('newCart.confirm'),
      canClose: false,
      backdropDismiss: false,
      isLight: true,
      children: (
        <div style={{ lineHeight: '22px' }}>
          {card.isIntegral && (discountMobx.discountResult.getIntegral !== 0) ? <div>1.{i18n.t('cart.deductionIntegral', { amount: toPrice(card.money, 2), integral: card.integral })}</div> : null}
          {card.isIntegralMoney ? <div>{card.isIntegral && (discountMobx.discountResult.getIntegral !== 0) ? '2' : '1'}.{i18n.t('cart.integralCostMoney', { count: discountMobx.discountResult.integral.integralNumber, amount: toPrice(discountMobx.discountResult.integral.integralCostMoney) })}</div> : null}
          {card.isIntegralMoney ? <div>{card.isIntegral && (discountMobx.discountResult.getIntegral !== 0) ? '3' : '2'}.{card.mallIntegralMoneyMaxType === 'discountRate' ? i18n.t('cart.integralMax2', { value: `${Math.round(card.mallIntegralMoneyMax * 10000) / 100}%` }) : i18n.t('cart.integralMax1', { value: toPrice(card.mallIntegralMoneyMax) })}</div> : null}
        </div>
      )
    }, 'showIntegralRuleModal').then((res: any) => {
    }).catch(async (res: any) => {
    })
  }

  const handleShowActivityDetailModal = () => {
    modalLayer(ActivityModal, {})
      .then(() => { })
      .catch(() => { })
  }

  const promoCodes = discountMobx.promoCodeCoupons?.filter(promoCode => promoCode.status === 'enable')
  return (
    <div className='mall-checkout-discount'>
      <div className='checkout-discount-mod cart-box-item discount-box-item' onClick={showPromoCode}>
        <div className='mod-left cart-item-left'>
          {/* <i className='iconfont icon-zhekou2x' style={{ color: '#F5A623' }}></i> */}
          <p>{i18n.t('cart.promoCode')}</p>
          {/* {discountMobx.usedPromoCodeCouponsCnt ? (<span className='equity-info'>{i18n.t('cart.useDiscountCount', { count: discountMobx.usedPromoCodeCouponsCnt })}</span>) : ''} */}
          {
            discountMobx.usedPromoCodeCouponsCnt && promoCodes.length ? (
              <>
                <span className='equity-info'>
                  {/* {
                    `${i18n.t(`cart.${promoCodes[0].isAllProduct ? 'promoCodeCouponsOverall' : 'promoCodeCouponsAssign'}`)}`
                  } */}
                  {promoCodes[0].discountType === 'discountFee' && i18n.t(`cart.${promoCodes[0].isAllProduct ? 'promoCodeCouponsOverallFee' : 'promoCodeCouponsAssignFee'}`, { fee: format.toPrice(promoCodes[0].discountValue) })}
                  {promoCodes[0].discountType === 'discountRate' && i18n.t(`cart.${promoCodes[0].isAllProduct ? 'promoCodeCouponsOverallRate' : 'promoCodeCouponsAssignRate'}`, { fee: format.toDiscount('discountRate', promoCodes[0].discountValue) })}
                  {promoCodes[0].discountType === 'specialOffer' && i18n.t(`cart.${promoCodes[0].isAllProduct ? 'promoCodeCouponsOverallSpecialOffer' : 'promoCodeCouponsAssignSpecialOffer'}`)}

                  {/* ${promoCodes[0].discountType === 'discountRate' ? format.toDiscount('discountRate', promoCodes[0].discountValue) : i18n.t('cart.discountPrice', { price: format.toPrice(promoCodes[0].discountValue) })} */}
                </span>
              </>
            ) : ''
          }
        </div>
        <div className='mod-right used-discount'>
          {
            discountMobx.promoCodeCoupons?.length ? (
              discountMobx.usedPromoCodeCouponsCnt && promoCodes.length ? (
                <span className='used-discount-price'>-{format.toPrice(cartResult.discountPromoCodeWholePrice + cartResult.discountPromoCodeItemPrice)}</span>
              ) : <span className='no-equity has-arrow'>{i18n.t('cart.noCanUse')} </span>
            ) : <span className='no-equity has-arrow'>{i18n.t('cart.noPromoCode')} </span>
            // <span className='no-equity has-arrow'>{i18n.t('cart.noUse')}</span>
          }
          <i className='iconfont icon-chevron-right' />
        </div>
      </div>
      {
        ((memberMobx.isLogin && memberMobx.memberInfo.type === 'member') || discountMobx.discountAction.promoCodes.length || !!cartResult.discountPromoCodePrice) && (
          <>
            <div className='checkout-discount-mod cart-box-item discount-box-item' onClick={showCoupon}>
              <div className='mod-left cart-item-left'>
                {/* <i className='iconfont icon-zhekou2x' style={{ color: '#F5A623' }}></i> */}
                <p>{i18n.t('cart.coupons')}</p>
                {discountMobx.usedCouponCnt ? (<span className='equity-info'>{i18n.t('cart.useDiscountCount', { count: discountMobx.usedCouponCnt })}</span>) : ''}
              </div>
              <div className='mod-right used-discount'>
                {
                  discountMobx.usedCouponCnt ? (
                    <span className='used-discount-price has-arrow'>-{format.toPrice(cartResult.discountCouponPrice + cartResult.discountItemCouponPrice)}</span>
                  ) : <span className='no-equity has-arrow'>{discountMobx.enabledCouponCnt ? i18n.t('cart.enabledCouponCnt', { length: discountMobx.enabledCouponCnt }) : i18n.t('cart.noCanUse')} </span>
                  // <span className='no-equity has-arrow'>{i18n.t('cart.noUse')}</span>
                }
                <i className='iconfont icon-chevron-right' />
              </div>
            </div>
          </>
        )
      }
      {
        cartResult.activityPrice ? (
          <div className='checkout-discount-mod cart-box-item discount-box-item'>
            <div className='mod-left cart-item-left'>
              <p>{i18n.t('cart.discountActivity')}</p>
              {/* <i className='iconfont icon-huiyuanka2x' style={{ color: '#24A148' }}></i> */}
              {/* <p className='equity-info'>{memberMobx.mallCardInfo?.card?.cardName}</p> */}
              <i className='iconfont icon-question1' onClick={handleShowActivityDetailModal}></i>
            </div>
            <div className='mod-right used-discount'>
              {/* <CardDiscountType discountItemPrice={cartResult.discountMemberCardPrice} /> */}
              <span className='used-discount-price no-arrow'>-{format.toPrice(cartResult.activityPrice || 0)}</span>
              {/* <i className='iconfont icon-chevron-right' /> */}
            </div>
          </div>
        ) : <></>
      }
      {
        memberMobx.mallCardInfo && (
          <div className='checkout-discount-mod cart-box-item discount-box-item' onClick={() => modalLayer(SwitchCardModal, { type: 'mall' }, 'switchCardModal').then(() => { }).catch(() => { })}>
            <div className='mod-left cart-item-left'>
              <p>{i18n.t('cart.memberCard')}</p>
              {/* <i className='iconfont icon-huiyuanka2x' style={{ color: '#24A148' }}></i> */}
              <p className='equity-info'>{memberMobx.mallCardInfo?.card?.cardName}</p>
            </div>
            <div className='mod-right used-discount'>
              {/* <CardDiscountType discountItemPrice={cartResult.discountMemberCardPrice} /> */}
              {
                cartResult.discountMemberCardPrice ? <span className='used-discount-price has-arrow'>-{format.toPrice(cartResult.discountMemberCardPrice || 0)}</span> : <></>
              }
              <i className='iconfont icon-chevron-right' />
            </div>
          </div>
        )
      }
      {
        memberMobx.mallCardInfo && cartResult.isCanPay && discountMobx.discountResult.isIntegralMoney && (!!discountMobx.discountResult?.integral?.useIntegral || !!memberMobx.mallCardInfo?.card?.isIntegral) ? (
          <div className='checkout-discount-mod cart-box-item discount-box-item'>
            <div className='mod-left cart-item-left'>
              <p>{i18n.t('cart.integral')}</p>
              <p className='equity-info integral'>{i18n.t('cart.integralTotal', { integral: discountMobx.discountResult.integral?.memberCardIntegral || 0 })}</p>
              <i className='iconfont icon-question1' onClick={showIntegralRule}></i>
              {/* <div className='mod-left-info'>
                <p className='nowrap'>
                  <span>(共{discountMobx.discountResult.integral?.memberCardIntegral}分)</span>
                  <i className='iconfont icon-info' onClick={showIntegralRule}></i>
                </p>
              </div> */}
            </div>
            <div
              className='mod-right used-discount'
              onClick={() => {
                if (!discountMobx.discountResult.integral?.useIntegral) return
                discountMobx.setIsUseIntegral(!discountMobx.discountAction.isUseIntegral)
              }}
            >
              {
                discountMobx.discountResult.integral?.useIntegral ? (
                  <div>
                    {cartResult.discountIntegralMoneyPrice > 0 ? <span className='used-discount-price'>-{format.toPrice(cartResult.discountIntegralMoneyPrice)}</span> : null}
                    {!discountMobx.discountResult.integral?.useIntegral ? '' : <i className={`iconfont ${discountMobx.discountAction.isUseIntegral ? 'icon-checkbox--checked--filled' : 'icon-checkbox'} ${!discountMobx.discountResult.integral?.useIntegral ? 'disabled' : ''}`} />}
                  </div>
                ) : (
                  <p className='no-equity'>{i18n.t('cart.unUseIntegralAsMoney')}</p>
                )
              }
              {/* {format.toPrice(discountMobx.discountResult.integral?.integralDiscountMoney || 0)} */}
            </div>
          </div>
        ) : null
      }
      {
        /** 手动单品折扣 */
        !!cartResult.orderPlanOffItem && (
          <div className='checkout-discount-mod cart-box-item discount-box-item'>
            <div className='mod-left cart-item-left'>
              {/* <i className='iconfont icon-zhekou2x' style={{ color: '#F5A623' }}></i> */}
              <p>{cartResult.orderPlanOffItem.offTip}</p>
            </div>
            <div className='mod-right used-discount'>
              -{format.toPrice(cartResult.orderPlanOffItem.off)}
            </div>
          </div>
        )
      }
    </div>
  )
}

export default observer(CheckoutDiscount)
